export default __webpack_public_path__ + "static/media/events.45c7fdd0.png";